import { mix } from "@chorda/core";
export const DropdownTrigger = (props) => {
    return mix({
        css: 'dropdown-trigger',
    }, {
        templates: {
            content: props.content
        },
    });
};
